import React from "react";
import { FileText } from "lucide-react";
import { EscPosBase64Decoder } from "../../../../utils/qztray/EscPosBase64Decoder";

interface Props {
  commands: any[];
}

const TicketVisualPreview: React.FC<Props> = ({ commands }) => {

  const renderCommand = (cmd: any, idx: number) => {
    const text = EscPosBase64Decoder.decodeToPrintableText(cmd.value) ?? "";

    switch (cmd.type) {
      case "TEXT":
        return (
          <div
            key={idx}
            className={`
              whitespace-pre font-mono text-[11px]
              ${cmd.align === "center" ? "text-center" : ""}
              ${cmd.align === "right" ? "text-right" : ""}
              ${cmd.style === "bold" ? "font-bold" : ""}
            `}
          >
            {text}
          </div>
        );

      case "RAW":
        // RAW puede representar FEED, CUT, DIVIDER, etc.
        // Para visualización simplemente mostramos espacio visual
        if (text.trim().length === 0) {
          return <div key={idx} className="h-2" />;
        }
        return (
          <div key={idx} className="whitespace-pre font-mono text-[11px]">
            {text}
          </div>
        );

      case "QR":
        return (
          <div key={idx} className="my-2 text-center">
            📌 [QR Code]
          </div>
        );

      case "IMAGE":
        return (
          <div key={idx} className="my-2 text-center">
            🖼️ [Imagen]
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <section className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark overflow-hidden transition">
      {/* Header */}
      <div className="border-b border-stroke dark:border-strokedark px-4 py-3 sm:px-5 xl:px-6 flex items-center gap-2">
        <FileText className="w-5 h-5 text-primary" />
        <h3 className="font-semibold text-black dark:text-white">
          Visualizador del Ticket
        </h3>
      </div>

      {/* Body */}
      <div className="p-4 sm:p-5 xl:p-6">
        <div className="bg-[#f9f9f9] dark:bg-gray-900 p-3 rounded-md overflow-y-auto max-h-[300px] text-xs font-mono text-gray-700 dark:text-gray-100 border border-gray-200 dark:border-gray-700">
          {commands.length > 0 ? (
            commands.map((cmd, idx) => renderCommand(cmd, idx))
          ) : (
            <p className="text-sm text-gray-500 italic">
              No hay comandos para mostrar.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default TicketVisualPreview;
